import { useCallback, useRef } from "react";
import { useMessageStore } from "../store";
import { webSocketService } from "../services/WebSocketService";
import {
  HeaderType,
  MessageNotRender,
  SocketConnectionStatus,
} from "../store/types";
import { useThrottledTyping } from "./useThrottledTyping";
import { isOverseaEnv } from "../utils/env";
import { escapeTextContent } from "../utils/string";
import { SEND_TYPING_INTERVAL, STOP_TYPING_DELAY } from "../constants";

export const useInputTyping = () => {
  const isConnected = useMessageStore((state) => state.isConnected);
  const currentContentRef = useRef("");

  const sendTyping = useCallback(
    (content: string) => {
      if (isConnected === SocketConnectionStatus.CONNECTED) {
        // 对内容进行转义处理后再发送
        const escapedContent = escapeTextContent(content);
        webSocketService.sendMessage(`{"text":"${escapedContent}"}`, {
          msgType: MessageNotRender.RealTime,
          headerType: HeaderType.SYSTEM,
          noNeedInsertToMsgList: true,
        });
      }
    },
    [isConnected],
  );
  const { sendTyping: throttledSendTyping, forceStop } = useThrottledTyping(
    sendTyping,
    () => {
      sendTyping(currentContentRef.current);
    },
    // 1000间隔发送，2000毫秒内停止
    { throttleInterval: SEND_TYPING_INTERVAL, stopDelay: STOP_TYPING_DELAY },
  );

  const onchangeInput = useCallback(
    (value: string) => {
      // 海外生产不使用该功能
      if (isOverseaEnv()) {
        return;
      }
      currentContentRef.current = value;
      // 只有在有内容输入时才触发typing事件
      throttledSendTyping(value);
    },
    [throttledSendTyping],
  );
  return {
    onchangeInput,
  };
};
